import * as types from "../../constants/types";

export const getTalent = () => {
  return {
    type: types.GET_TALENT_BEGIN,
  };
};
